<div class="auth-login position-relative overflow-hidden d-flex align-items-center justify-content-center px-7 px-xxl-0 rounded-3 h-n20">
    <div class="position-relative w-100">
        <canvas id="hero-shader" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0;"></canvas>
        <div class="auth-login-wrapper card mb-0 container position-relative z-1 h-100 mh-n100" data-simplebar>
            <div class="card-body">
                <!--
                <a href="../main/index.html" class="">
                    <img src="../assets/images/logos/logo-dark.svg" class="light-logo" alt="Logo-Dark" />
                    <img src="../assets/images/logos/logo-light.svg" class="dark-logo" alt="Logo-light" />
                </a>
                -->
                <div class="row align-items-center justify-content-around pt-6 pb-5">
                    <div class="col-lg-6 col-xl-5 d-none d-lg-block">
                        <div class="text-center text-lg-start">
                            <img src="/assets/img/auth-logo.png" alt="spike-img" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-5">
                        <section data-id="forgot-password-form-container" style="display: block">
                            <h2 class="mb-6 fs-8 fw-bolder">Forgot your password?</h2>
                            <p class="text-dark fs-4 mb-7">Please enter the email address associated with your account and we will
                                email you a link to reset your password.</p>
                            <form data-id="form-forgot-password">
                                <div class="mb-7">
                                    <label for="forgotPasswordRegion"
                                           class="form-label fw-bold">Region</label>
                                    <select class="form-select py-6"
                                            id="forgotPasswordRegion"
                                            name="region"
                                            data-id="select-region"
                                            required>
                                        <option value="" disabled selected>Select your region</option>
                                        <option value="eu">Europe (EU)</option>
                                        <option value="us">United States (US)</option>
                                    </select>
                                </div>
                                <div class="mb-7">
                                    <label for="forgotPasswordEmail" class="form-label fw-bold">Email address</label>
                                    <input type="email"
                                           class="form-control py-6"
                                           id="forgotPasswordEmail"
                                           name="email"
                                           aria-describedby="emailHelp"
                                           required>
                                </div>
                                <button data-id="btn-forgot-password"
                                        type="button"
                                        class="btn btn-primary w-100 mb-3 rounded-pill">Forgot Password</button>
                                <button data-id="btn-forgot-password-loading"
                                        class="btn btn-primary w-100 mb-3 rounded-pill"
                                        type="button"
                                        style="display: none;"
                                        disabled="">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </button>
                                <div data-id="forgot-password-error-container"
                                     class="invalid-feedback mb-3"></div>
                                <a href="/login" class="btn bg-primary-subtle text-primary w-100 rounded-pill">Back to Login</a>
                            </form>
                        </section>
                        <section data-id="forgot-password-success-container" style="display: none">
                            <h2 class="mb-6 fs-8 fw-bolder">Help is on the way!</h2>
                            <p class="text-dark fs-4 mb-7">We've sent password reset instructions to your email address.</p>
                            <p class="text-dark fs-4 mb-7">Click the link in the email to set a new password. If you don't see it within a few minutes, check your spam folder.</p>
                            <a href="/login" class="btn btn-primary w-100 rounded-pill">Back to Login</a>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="dark-transparent sidebartoggler"></div>
